import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { defaultPageSize } from "../../utils/const";
import { initialState, ISetPageState } from "../emptyStates/PagePersisting";

export const pageState = createSlice({
  name: "pagePersisting",
  initialState,
  reducers: {
    setPageState: (state, action: PayloadAction<ISetPageState>) => {
      const { pathname, pageState } = action.payload;
      state[pathname] = {
        ...(state[pathname]), 
        ...pageState,
      }
    },
    setScrollPosition: (state, action: PayloadAction<ISetPageState>) => {
      const { pathname, scrollPosition } = action.payload;
      state[pathname] = {
        ...(state[pathname]), 
        scrollPosition,
      }
    },
    clearPageState: (state, action: PayloadAction<{ pathname: string }>) => {
      delete state[action.payload.pathname];
    },
  },
});

export const { setPageState, setScrollPosition, clearPageState } = pageState.actions;
export default pageState.reducer;
